import React, { useState, useEffect } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import "../../../../styles/userManagement.css";
import ViewIssueTable from "./viewIssues";
import ManageIssueTable from "./manageIssues";

import useHttp from "../../../../hooks/useHttp";
import APIService from "../../../../services/apiAxiosService";
let IssueManagement = () => {
  const [currentTab, SetTab] = useState("1");
  const [reset, setReset] = useState(false);
  const [viewIssues, setViewIssues] = useState([]);
  const [vendors, setVendors] = useState();
  const [assessment, setAssessment] = useState();
  const [analyst, setAnalyst] = useState();
  const [risk, setRiskData] = useState();
  const [manageIssuesRequests, setAllManageIssuesRequests] = useState([]);
  const [closeIssuesRequests, setAllCloseIssuesRequests] = useState();
  const { sendRequest: getCloseIssuesRequestsAPI } = useHttp();
  const { sendRequest: getManageIssuesRequestsAPI } = useHttp();
  const { sendRequest: getAllVendorViewIssuesAPI } = useHttp();
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: getAllAnalystDataAPI } = useHttp();
  const { sendRequest: getAssessmentDataAPI } = useHttp();
  const { sendRequest: getManageRiskData } = useHttp();
  const handleTabs = (e, v) => {
    SetTab(v);
    setReset(!reset);
  };
  const getAllViewIssuesData = async () => {
    const VendorId=sessionStorage.getItem('vendorId');
    await getAllVendorViewIssuesAPI(
      APIService.getAllVendorViewIssues(VendorId),
      (data) => {
        data.MSG.forEach(function (a) {
          a.created_date = a.created_date.substring(0, 10);
          a.issuedue_date = a.issuedue_date.substring(0, 10);
        });
        setViewIssues(data.MSG);
      }
    );
  };
  const getManageIssuesRequest = async () => {
    await getManageIssuesRequestsAPI(
      APIService.getManageIssuesRequests(),
      (data) => {
        data.MSG.forEach(function (a) {
          a.created_date = a.created_date.substring(0, 10);
          a.issuedue_date = a.issuedue_date.substring(0, 10);
        });
        setAllManageIssuesRequests(data.MSG);
      }
    );
  };
  const getCloseIssuesRequest = async () => {
    await getCloseIssuesRequestsAPI(
      APIService.getCloseIssuesRequests(),
      (data) => {
        data.MSG.forEach(function (a) {
          a.created_date = a.created_date.substring(0, 10);
          a.issuedue_date = a.issuedue_date.substring(0, 10);
        });
        setAllCloseIssuesRequests(data.MSG);
      }
    );
  };
  const getAllVendorListData = async () => {
    getAllVendorList(APIService.getAllVendorList(), (data) => {
      setVendors(data.MSG);
    });
  };
  const getAssessmentDetails = async () => {
    await getAssessmentDataAPI(APIService.getAssessmentData(), (data) =>
      setAssessment(data.MSG)
    );
  };
  const getRiskData = async () => {
    getManageRiskData(APIService.getManageRiskData(), (data) => {
      setRiskData(data.MSG);
    })
  };
  const getAllAnalyst = async () => {
    await getAllAnalystDataAPI(APIService.getAllAnalystData(), (data) =>
      setAnalyst(data.MSG)
    );
  };
  useEffect(() => {
    getAllViewIssuesData();
    getAllVendorListData();
    getAssessmentDetails();
    getRiskData();
    getAllAnalyst();
    getManageIssuesRequest();
    // getCloseIssuesRequest();
  }, []);
  return (
    <div className="user-management-container">
      <Tabs
        defaultValue={currentTab}
        value={currentTab}
        onChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="1" label="View Issues">
          <ViewIssueTable
            reset={reset}
            reload={getAllViewIssuesData}
            reloadIssue={getManageIssuesRequest}
            viewIssues={viewIssues}
            vendors={vendors}
            assessment={assessment}
            risk={risk}
            analyst={analyst}
          />
        </Tab>
        <Tab value="2" label="Manage Actions">
          <ManageIssueTable
            reset={reset}
            reload={getManageIssuesRequest}
            reloadManageIssue={getCloseIssuesRequest}
            viewIssues={manageIssuesRequests}
            vendors={vendors}
            assessment={assessment}
            risk={risk}
            analyst={analyst}
          />
        </Tab>
       
      </Tabs>
    </div>
  );
};

export default IssueManagement;
